import objectToFormData from 'object-to-formdata'
import qs from 'querystring'
import Url from 'url'
import CryptoJS from "crypto-js";
import { isPlainObject, type } from './jqUtil'
import showAlert from './showAlert';
import postDownload from "./postDownload";
import { isNil } from 'lodash';
import { isDevOrTest } from './datracker';
import { axiosErrorHandle } from "#utils/axiosErrorHandle";
import { $sType, isOuterIpService } from './sType';
import { apiVersionCheck } from './versionCheck';
import ServiceError from '@mpc/common/src/utils/serviceError';
import FetchError from '@mpc/common/src/utils/fetchError';
import { PartnershipRequestInvoker } from '@purchase/supplier'
import { removeVendorStorage } from './vendorStorage';

/** 跳转登录页 */
export const skipToLogin = () => {
    // 在开发环境不跳转登录
    // if (isDevOrTest()) {
    //     return;
    // }
    if ($sType === 'outer' && !isOuterIpService()) {
        if (['#/forget', '#/reset'].some(item => window.location.hash.includes(item))) { // 忘记密码和重置密码不跳转登录
            return;
        }
        // 外包登录走中台
        removeVendorStorage();
        PartnershipRequestInvoker.getInstance().authLogin()
        return
    }
    // IP 服务（外包+ip）跳前端登录页，不走内包登录接口
    if (isOuterIpService()) {
        window.location.hash = '#/login';
        return
    }
    const loginUrl = apiVersionCheck(3) ? '/api/v2/java_proxy/accounts/login' : '/api/v1/accounts/login';
    window.location.href = loginUrl;
}

export const clearNull = (body, convertEmptyArray = false) => {
    let temp

    if (Array.isArray(body)) {
        const newBody = []

        if (body.length) {
            body.filter(item => item !== null).forEach(item => {
                temp = clearNull(item, convertEmptyArray)

                if (temp !== null) {
                    newBody.push(temp)
                }
            })
        }

        return newBody.length ? newBody : (convertEmptyArray ? [''] : null)
    } else if (isPlainObject(body)) {
        const newBody = {}

        for (let key in body) {
            if (body[key] === null) {
                continue
            }

            temp = clearNull(body[key], convertEmptyArray)

            if (temp !== null) {
                newBody[key] = temp
            }
        }

        return newBody
    } else {
        return body
    }
}

// 针对返回的结果单独处理['']约定的数据
const convertResult = body => {
    if (Array.isArray(body)) {
        if (body.length === 1 && body[0] === '') {
            return []
        }

        body.forEach((item, index) => {
            body[index] = convertResult(item)
        })

        return body
    } else if (isPlainObject(body)) {
        for (let key in body) {
            body[key] = convertResult(body[key])
        }

        return body
    } else {
        return body
    }
}

// 幂等相关
const REQUEST_UUID_MAP = new Map();
const createUUID = () => {
    let dt = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};
const setRequestUUID = (ajaxParams) => {
    const { url, method, body, headers } = ajaxParams || {};
    const bodyJson = JSON.stringify(body || {});
    const bodyJsonHash = CryptoJS.SHA1(bodyJson).toString();
    const uuidKey = `${method}:${url || ""}@${bodyJsonHash}`;

    if (!REQUEST_UUID_MAP.get(uuidKey)) {
        REQUEST_UUID_MAP.set(uuidKey, createUUID());
    }

    const uuidValue = REQUEST_UUID_MAP.get(uuidKey);

    // Object.assign(ajaxParams.body || {}, { uuid: uuidValue });
    // Object.assign(ajaxParams.headers || {}, { "X-MPC-UUID" : uuidValue });
    ajaxParams.headers["X-MPC-UUID"] = uuidValue;

    return uuidKey;
};
const removeRequestUUID = (uuidKey) => {
    REQUEST_UUID_MAP.delete(uuidKey);
};

/**
 * alert = false
 * alert = true
 * alert = ''
 * alert = {
 * 待发送请求
 *  pending: '',
 *  成功处理
 *  fulfilled: '' || { type: '', msg: '' }
 *  失败处理
 *  rejected: true || '' || { type: '', msg: '' }
 * }
 * @returns {*}
 */
export default function(options = {}) {
    let bodyTemp = options.body
    options = Object.assign({
        method: 'GET',
        headers: {},
        body: {},
        dataType: options ? .url ? .match(/\.(html|css)/) ? 'text' : 'json',
        alert: true
    }, options, { body: bodyTemp })

    const { withUUID = true } = options
    let { alert, body, method, silent } = options

    if (alert) {
        if (isPlainObject(alert)) {
            if (!('rejected' in alert)) {
                alert.rejected = true
            }

            const { pending, fulfilled, rejected } = alert

            if (pending !== undefined) {
                if (type(pending) === 'string') {
                    alert.pending = { type: 'info', msg: pending }
                } else if (!isPlainObject(pending)) {
                    delete alert.pending
                }
            }

            if (fulfilled !== undefined) {
                if (type(fulfilled) === 'boolean' && fulfilled) {
                    alert.fulfilled = { type: 'success' }
                } else if (type(fulfilled) === 'string') {
                    alert.fulfilled = { type: 'success', msg: fulfilled }
                } else if (!isPlainObject(fulfilled)) {
                    delete alert.fulfilled
                }
            }

            if (rejected !== undefined) {
                if (type(rejected) === 'boolean' && rejected) {
                    alert.rejected = { type: 'danger' }
                } else if (type(rejected) === 'string') {
                    alert.rejected = { type: 'danger', msg: rejected }
                } else if (!isPlainObject(rejected)) {
                    delete alert.rejected
                }
            }
        } else if (type(alert) === 'boolean') {
            alert = { rejected: { type: 'danger' } }
        } else if (type(alert) === 'string') {
            alert = { rejected: { type: 'danger', msg: alert } }
        }
    }

    let uuidKey;
    if (withUUID && ['POST', "PUT", "DELETE"].includes(method)) {
        uuidKey = setRequestUUID(options);
    }

    if (method === 'GET') {
        const urlObject = Url.parse(options ? .url)

        urlObject.query = Object.assign(urlObject.query || {}, body)
        options.url = Url.format(urlObject)
        delete options.body
    } else {
        // 对当前系统添加csrf token
        // if (isLocalRequest) {
        //   options.headers['csrftoken'] = csrfToken
        // }
        const contentType = options.headers['Content-Type']

        if (options.useFormData && options.body) {
            options.body = objectToFormData(options.body)
        } else if (isPlainObject(body)) {
            //默认使用json方式传递数据
            if (!contentType || contentType === 'json') {
                options.headers['Content-Type'] = 'application/json; charset=utf-8'
                options.body = JSON.stringify(body)
            } else if (contentType === 'form') {
                options.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
                options.body = qs.stringify(body)
            }
        }
    }

    options.headers['X-Requested-With'] = 'XMLHttpRequest'

    // 添加前端版本号
    options.headers['x-fe-version-tag'] = window.$versionTag || 'dev'

    if (isDevOrTest()) {
        const querystring = location.search ? location.search.slice(1) : '';
        const querystringInfo = qs.parse(querystring);
        const { id = '' } = querystringInfo;

        if (id) {
            options.headers['User'] = id;
        }

        // 对接本地java接口的时候用，记得改API的proxy
        // options.headers['Authorization'] = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiLpg63mmZPmmZMiLCJqdGkiOiIxNTMzIiwiaWF0IjoxNjk5MjY1MzQ1LCJJRCI6MTUzMywiUk9MRV9BRE1JTiI6dHJ1ZSwiTUFJTCI6Imh6Z3VveGlhb3hpYW9AY29ycC5uZXRlYXNlLmNvbSIsImV4cCI6MTY5OTI3MjU0NX0.iyCZp2SuJv8NzfRrUg8BsuRA7dT6MtPZ3FxNUF5zz7n7k8Sa4_A7T08-n039NZzM1Ttx_P9nrf68vB8NyQqYdQ';
    }

    let { openapi, url, dataType, version = "v1", ...otherOptions } = options
    url = openapi ? url : `/api/${version}/` + url

    return fetch(url, Object.assign(otherOptions, { credentials: 'same-origin' }))
        .then(response => {
            if (!response.ok) {
                const error = new Error(response.statusText)
                error.response = response
                throw error
            }

            const headers = response.headers
            const contentDisposition = headers.get('Content-Disposition')
            const contentType = headers.get('Content-Type')
                // 如果返回文件，检测返回头是否有文件标识
            if (dataType === 'blob') {
                if (contentDisposition) {
                    if (method === 'POST') {
                        return postDownload(response, options);
                    } else {
                        return response[dataType]().then(data => {
                            if (options.fileName) {
                                return data
                            }
                        })
                    }

                } else {
                    dataType = 'json'
                    return response.json()
                }
            }

            return response[dataType]()
        })
        .then(result => {
            if (dataType === 'json') {
                result = convertResult(result);

                // 兼容java接口
                if (isNil(result.res_code) && !isNil(result.code)) {
                    result.res_code = result.code;
                }
                // 兼容java接口
                if (!result.res_msg && result.message) {
                    result.res_msg = result.message;
                }

                if (result.res_code !== undefined) {
                    // 用户未登录判断
                    if (result.res_code === -1) {
                        // 如果未登录且已加载 表示登录超时 强制刷新
                        // 只能在生产模式使用
                        // TODO 弹出登录丢失提示框
                        skipToLogin();
                    } else if (result.res_code === 0 || result.res_code !== 1) {
                        const errMessage = Array.isArray(result.res_msg) ? result.res_msg.join('<br/>') : (
                                typeof(result.res_msg) === 'string' ? result.res_msg : ''
                            )
                            // 静默模式不弹出错误提示
                        if (!silent) {
                            if (axiosErrorHandle.handle) {
                                axiosErrorHandle.handle ? .(result)
                            } else {
                                showAlert({
                                    type: 'error',
                                    message: errMessage || '服务器错误',
                                    hideDelay: options ? .errorAlertDuration || 3000
                                });
                            }
                        }
                        let error = new Error(errMessage)
                        error.data = {...result }
                        throw error
                    } else if (result.res_code === 1) {
                        // success
                    } else {
                        throw new Error('服务器错误')
                    }
                }
            }

            if (alert && alert.fulfilled) {
                if (!alert.fulfilled.msg) {
                    alert.fulfilled.msg = result.msg
                }
            }

            if (uuidKey) {
                removeRequestUUID(uuidKey);
            }

            return result
        })
        .catch(e => {
            if (e && e.response && e.response.status == 403) {
                window.location.href = '/'
                return
            }

            if (e.message.indexOf("Failed to fetch") > -1) {
                const errMessage = JSON.stringify({
                    ...options,
                    url,
                    name: e.name,
                    message: e.message,
                }, )
                throw new FetchError(errMessage)
            } else if (alert && alert.rejected) {
                if (!alert.rejected.msg) {
                    alert.rejected.msg = e.message
                }
            }

            showAlert({
                type: 'error',
                message: e.message || '服务器错误',
                hideDelay: options ? .errorAlertDuration || 3000
            });

            throw new ServiceError(typeof e === 'string' ? e : e.message || '服务器错误')
        })
}